import { styled } from '@mui/material'

const CenteredContent = styled('div')({
  width: '100%',
  height: '100%',
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',
})

export default CenteredContent
